<page-load-header *ngIf="!initialized"></page-load-header>

<gait-analysis-result-details [isCoachView]="false" [isShared]="true"></gait-analysis-result-details>


